// src/app/features/admin/dfnsWebhooksApi.js
import http from "../../api/http";

export async function getDfnsWebhookHealth() {
  const res = await http.get("/webhooks/dfns/health");
  return res.data;
}

export async function getDfnsWebhookLogs(limit = 10) {
  const res = await http.get("/webhooks/dfns/logs", {
    params: { limit },
  });
  return res.data;
}
